import React from 'react';


const useResponsive = (width) => {
  const [isMobile, setIsMobile] = React.useState(false);
  const [isCustomBreakpoint, setIsCustomBreakpoint] = React.useState(false);
  const [isTablet, setIsTablet] = React.useState(false);
  const [isBootstrapTablet, setIsBootstrapTablet] = React.useState(false);

  const setValues = () => {
    setIsMobile(window.innerWidth < 768);
    setIsCustomBreakpoint(window.innerWidth <= width);
    setIsTablet(window.innerWidth <= 1199 && window.innerWidth >= 768);
    setIsBootstrapTablet(window.innerWidth <= 1023);
  };

  const interval = setInterval(() => {
    setValues();
    clearInterval(interval);
  }, 10);

  React.useEffect(() => {
    setValues();
    const handleWindowResize = () => {
      setValues();
    };
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return { isMobile, isBootstrapTablet, isTablet, isCustomBreakpoint };
};

export default useResponsive;
